import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, StatusBadge, fmtDate } from "@/components/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => setLogs([])); }, []);

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Logs" subtitle="Immutable record of actions across the platform." />
      <div className="border border-border rounded-lg bg-card overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="hover:bg-transparent">
                <TableHead className="text-xs uppercase tracking-wider">Action</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">Entity</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">User</TableHead>
                <TableHead className="text-xs uppercase tracking-wider">When</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs === null ? (
                <TableRow><TableCell colSpan={4} className="text-center py-12"><Loader2 className="w-5 h-5 animate-spin mx-auto text-primary" /></TableCell></TableRow>
              ) : logs.length === 0 ? (
                <TableRow><TableCell colSpan={4} className="text-center py-12 text-muted-foreground">No logs.</TableCell></TableRow>
              ) : logs.map((l) => (
                <TableRow key={l.id} data-testid="audit-row">
                  <TableCell className="py-2.5"><StatusBadge value={l.action} /></TableCell>
                  <TableCell className="py-2.5">{l.entity_type?.replace(/_/g, " ")}</TableCell>
                  <TableCell className="py-2.5 text-muted-foreground">{l.user_name || l.user_email || "system"}</TableCell>
                  <TableCell className="py-2.5 text-muted-foreground text-sm">{fmtDate(l.created_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
